import { Compass, Gem, Handshake } from "lucide-react";
import FadeIn from "./FadeIn";

const ITEMS = [
  {
    icon: Compass,
    title: "STRATEGIC ADVICE",
    text: "Smart mortgage strategies tailored to your financial goals.",
  },
  {
    icon: Gem,
    title: "EXCLUSIVE SOLUTIONS",
    text: "Access to multiple lending options and mortgage products.",
  },
  {
    icon: Handshake,
    title: "PERSONALIZED SERVICE",
    text: "Dedicated guidance from application through closing.",
  },
];

export default function Trust() {
  return (
    <section data-testid="trust-section" className="relative py-24 lg:py-32">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 grid md:grid-cols-3 gap-6">
        {ITEMS.map((item, i) => (
          <FadeIn key={item.title} delay={i * 0.12} variant="depth">
            <div
              data-testid={`trust-card-${i}`}
              className="glass-panel depth-card rounded-md p-10 h-full"
            >
              <div className="w-12 h-12 rounded-full border border-gold/30 flex items-center justify-center mb-8">
                <item.icon size={20} strokeWidth={1.25} className="text-gold" />
              </div>
              <h3 className="text-sm tracking-[0.22em] font-medium text-ivory mb-4">{item.title}</h3>
              <p className="text-ivory/55 font-light leading-relaxed text-[15px]">{item.text}</p>
            </div>
          </FadeIn>
        ))}
      </div>
    </section>
  );
}
